import { useEffect, useRef } from 'react'
import { supabaseAdmin } from '../lib/supabase'

/**
 * Hook that creates REAL Supabase Realtime subscriptions on specific tables
 * and calls a refresh callback when changes (INSERT/UPDATE/DELETE) are detected.
 *
 * Usage:
 *   useRealtimeRefresh(['invoices', 'credit_notes'], loadData)
 */
export function useRealtimeRefresh(tables: string[], onRefresh: () => void) {
  const onRefreshRef = useRef(onRefresh)
  onRefreshRef.current = onRefresh

  useEffect(() => {
    if (tables.length === 0) return

    const channelName = `rt-${tables.join('-')}-${Math.random().toString(36).slice(2, 8)}`
    const channel = supabaseAdmin.channel(channelName)

    tables.forEach((table) => {
      channel.on(
        'postgres_changes',
        { event: '*', schema: 'public', table },
        (payload) => {
          console.log(
            `[useRealtimeRefresh] ${table} ${payload.eventType} — refreshing`,
          )
          onRefreshRef.current()
        },
      )
    })

    channel.subscribe((status) => {
      console.log(`[useRealtimeRefresh] ${channelName}: ${status}`)
    })

    return () => {
      supabaseAdmin.removeChannel(channel)
    }
  }, [tables.join(',')])
}
